import { TaskStatus } from "@/types/tasks";

/**
 * Shared task status options for dropdowns/selects across the app.
 * Single source of truth — update here to change everywhere.
 */
export const TASK_STATUS_OPTIONS: { label: string; value: TaskStatus }[] = [
  { label: "Not Started", value: "NOT_STARTED" },
  { label: "In Progress", value: "IN_PROGRESS" },
  { label: "Completed", value: "COMPLETED" },
  // { label: "Discarded", value: "DISCARDED" }, // Hidden from UI per feedback
];

/**
 * All valid task status values (for zod schemas, validation, etc.)
 */
export const ALL_TASK_STATUSES: TaskStatus[] = [
  "NOT_STARTED",
  "IN_PROGRESS",
  "COMPLETED",
  "NOT_REQUIRED",
  "MISSED",
];

/**
 * Statuses considered "completed/resolved" for progress calculations.
 */
export const COMPLETED_TASK_STATUSES: TaskStatus[] = [
  "COMPLETED",
  "MISSED",
  "NOT_REQUIRED",
];

/**
 * Statuses considered "active" (still in-progress).
 */
export const ACTIVE_TASK_STATUSES: TaskStatus[] = ["NOT_STARTED", "IN_PROGRESS"];
